import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from '~/store/hooks';

interface ProcessedAigssEventsSliceState {
  ids: { [key: string]: boolean };
}

const initialState: ProcessedAigssEventsSliceState = {
  ids: {},
};

const processedAigssEventsSlice = createSlice({
  initialState,
  name: 'processedAigssEvents',
  reducers: {
    processAigssEventId: (state, action: PayloadAction<string>) => {
      state.ids[action.payload] = true;
    },
  },
});

export const { processAigssEventId: processAigssEventIdAction } =
  processedAigssEventsSlice.actions;

export default processedAigssEventsSlice.reducer;

export const useProcessedAigssEventsSelector = () => {
  return useAppSelector((state) => state.processedAigssEvents);
};

export const useProcessAigssEventsDispatch = () => {
  const dispatch = useAppDispatch();

  const processAigssEventId = (id: string) => {
    dispatch(processAigssEventIdAction(id));
  };

  return {
    processAigssEventId,
  };
};
